import IconsEnum from "../../classes/enums/IconsEnum";
import ButtonWithIcon from "../button/ButtonWithIcon";
import "./navigationButtons.css";
const NavigationButtons = ({
  steps,
  currentStepIndex,
  previousGroupButtonText = "Previous",
  onPrevGroup = () => {},
  isPreviousButtonDisabled = true,
  nextGroupButtonText = "Next",
  onNextGroup = () => {},
  isNextButtonDisabled = false,
  confirmButtonText = "Confirm",
  onConfirmClick = () => {},
  isConfirmButtonDisabled = true,
}) => {
  const handleNextGroup = () => {
    if (currentStepIndex < steps.length - 1) {
      onNextGroup();
    }
  };

  const handlePrevGroup = () => {
    if (currentStepIndex > 0) {
      onPrevGroup();
    }
  };

  const handleConfirmClick = () => {
    onConfirmClick();
  };

  return (
    <div className="navigation-buttons-container">
      {steps.length > 1 && (
        <>
          {currentStepIndex > 0 && (
            <ButtonWithIcon
              value={previousGroupButtonText}
              onClick={handlePrevGroup}
              disabled={isPreviousButtonDisabled}
              className="prev-button"
              icon={IconsEnum.GOBACK}
            />
          )}
          {currentStepIndex < steps.length - 1 && (
            <ButtonWithIcon
              value={nextGroupButtonText}
              onClick={handleNextGroup}
              disabled={isNextButtonDisabled}
              className="next-button"
            />
          )}
        </>
      )}

      {(currentStepIndex === steps.length - 1 || steps.length === 1) && (
        <ButtonWithIcon
          value={confirmButtonText}
          onClick={handleConfirmClick}
          disabled={isConfirmButtonDisabled}
          className="confirm-button"
        />
      )}
    </div>
  );
};

export default NavigationButtons;
